import { DettaglioAdempimento } from './dettaglio-adempimento';
import { DocumentoAllegato } from './documento-allegato';
import { Rinvio } from './rinvio';
import { Motivo } from './tipologiche/motivo';
import { MotivoScadenza } from './tipologiche/motivo-scadenza';
import { Priorita } from './tipologiche/priorita';
import { TipoScadenza } from './tipologiche/tipo-scadenza';

export class Scadenza {
  id: string;
  tipoScadenza: TipoScadenza;
  motivo: MotivoScadenza;
  motivoEvasione: Motivo;
  priorita: Priorita;
  dataScadenza: number;
  dataCreazione: number;
  dataPromemoria: number;
  pubblica: boolean = true;
  evasa: boolean;
  dataEvasione: number;
  inviaNotifica?:boolean;
  appunto: string;
  note: string;
  rinvioScadenza: Rinvio[];
  documenti: DocumentoAllegato[];
  lastRinvioScadenza: Rinvio;
  giorniRitardo: number;
  ora: number;
  descrizione: string;
  isOpen: boolean;
  assegnatario?: string;
  dettaglioEsitoAdempimento?: DettaglioAdempimento;
}
